<template>
  <div id="news_main">
    <div class="main">
      <div class="title_bar">
        <div class="left">
          <div class="title">
            社區廠商
          </div>
          <div class="tip">
            可檢視社區廠商聯絡資料與介紹
          </div>
        </div>
      </div>
      <filter-frame
        ref="filter"
        :save-filter="true"
        :filter-form="depositFilter"
        @search="search"
        @clear="clearSearch()"
        @change="setAreaList"
      />
      <div class="title_bar center">
        <div class="left" />
        <div class="right">
          <el-button
            icon="icon-plus"
            round
            @click="$router.push({name:'supplierEdit'})"
          >
            新增廠商
          </el-button>
          <el-button
            icon="icon-output"
            round
            @click="exportSupplier"
          >
            匯出
          </el-button>
        </div>
      </div>
      <el-table
        class="newslist"
        :data="ListData"
        empty-text="目前無任何廠商"
      >
        <el-table-column
          type="index"
          width="50"
        />
        <el-table-column
          prop="SupplierName"
          label="名稱"
        >
          <template slot-scope="scope">
            <span
              class="news-title"
              @click.stop="$router.push({name:'supplierDetail', query: {supplierId: scope.row.SupplierId}})"
            >
              {{ scope.row.SupplierName }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="TypeName"
          label="類別"
          width="110"
        />
        <el-table-column
          prop="SubTitle"
          label="簡述"
          width="110"
        />
        <el-table-column
          prop="SupplierTel"
          label="電話"
          width="110"
        />
        <el-table-column
          prop="SupplierPhone"
          label="手機"
          width="110"
        />
        <el-table-column
          label="地址"
          width="250"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.City }}{{ scope.row.Area }}{{ scope.row.Address }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="180"
        >
          <template slot-scope="scope">
            <el-button
              size="mini"
              plain
              @click="$router.push({name:'supplierEdit', query: {supplierId: scope.row.SupplierId}})"
            >
              編輯
            </el-button>
            <el-button
              size="mini"
              type="danger"
              plain
              @click="handleDel(scope.row.SupplierId)"
            >
              刪除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <TableLoading :is-loading="loading" />
      <el-pagination
        background
        layout="total, prev, pager, next, jumper"
        :page-size="maxCount"
        :total="listTotalCount"
        @current-change="getList"
      />
    </div>
  </div>
</template>
<script>
import TableLoading from '@/components/TableLoading'

import filterFrame from '@/components/FilterFrame'
export default {
  components: {
    'filter-frame': filterFrame,
    TableLoading
  },
  data () {
    return {
      filter: {
        name: '',
        type: [],
        city: '',
        area: '',
        road: ''
      },
      scrollEnd: false,
      loading: false,
      maxCount: 10,
      listTotalCount: 0,
      nowPage: 1,
      depositFilter: [
        {
          label: '名稱',
          name: 'name',
          type: 'input'
        },
        {
          label: '類別',
          name: 'type',
          type: 'multiselect',
          options: []
        },
        {}, // 為了排版而留
        {
          label: '縣市',
          name: 'city',
          type: 'select',
          options: []
        },
        {
          label: '區域',
          name: 'area',
          type: 'select',
          options: []
        },
        {
          label: '路名',
          name: 'road',
          type: 'input'
        }
      ],
      ListData: [],
      cityAreaList: []
    }
  },
  mounted () {
    this.getTypes()
    this.getCityAreaList()
    this.getList()
  },
  activated () {
    this.getList()
  },
  methods: {
    getTypes () {
      return new Promise((resolve, reject) => {
        apiAsset.Supplier.GetSupplierTypes()
          .then(res => {
            this.depositFilter[1].options = res.data.map(item => {
              return {
                label: item.name,
                value: item.id
              }
            })
            resolve()
          })
          .catch(err => {
            console.log(err)
            reject(new Error('取得廠商類別失敗'))
          })
      })
    },
    getCityAreaList () {
      return new Promise((resolve, reject) => {
        apiAsset.Supplier.GetCityAreas()
          .then(res => {
            this.cityAreaList = res.data
            this.depositFilter[3].options = this.cityAreaList.map(item => {
              return {
                label: item.CityName,
                value: item.CityName
              }
            })
            resolve()
          })
          .catch(err => {
            console.log(err)
            reject(new Error('取得城市區域失敗'))
          })
      })
    },
    setAreaList (index, value) {
      if (index === 3) {
        const city = this.cityAreaList.find(item => item.CityName === value)
        this.depositFilter[4].options = city.Areas.map(item => {
          return {
            label: item,
            value: item
          }
        })
      }
    },
    // 查詢
    search (such_val) {
      this.filter = {
        // eslint-disable-next-line eqeqeq
        name: such_val.name == undefined ? '' : such_val.name,
        // eslint-disable-next-line eqeqeq
        type: such_val.type == undefined ? [] : such_val.type,
        // eslint-disable-next-line eqeqeq
        city: such_val.city == undefined ? '' : such_val.city,
        // eslint-disable-next-line eqeqeq
        area: such_val.area == undefined ? '' : such_val.area,
        // eslint-disable-next-line eqeqeq
        road: such_val.road == undefined ? '' : such_val.road
      }
      this.ListData = []
      this.scrollEnd = false
      window.scrollTo(0, 0)
      this.getList()
    },
    // 清除條件
    clearSearch () {
      this.filter = {
        name: '',
        type: [],
        city: '',
        region: '',
        road: ''
      }
      this.ListData = []
      this.scrollEnd = false
      window.scrollTo(0, 0)
      this.getList()
    },
    // 取得公告列表
    getList (page = 1) {
      this.loading = true
      this.nowPage = page
      return new Promise((resolve, reject) => {
        const { name, type, city, area, road } = this.filter
        const params = {
          Offset: (page - 1) * this.maxCount,
          MaxCount: this.maxCount,
          'Filter.Name': name,
          'Filter.TypeIds': type,
          'Filter.City': city,
          'Filter.Area': area,
          'Filter.Address': road
        }
        apiAsset.Asset.GetSuppliers(params)
          .then(res => {
            console.log(res)
            this.ListData = res.data.Data
            this.listTotalCount = res.data.Total
            this.loading = false
            resolve()
          })
          .catch(err => {
            console.log(err)
            this.loading = false
            reject(new Error('取得廠商列表失敗'))
          })
      })
    },
    // 刪除廠商
    handleDel (SupplierId) {
      this.$confirm('確認刪除該筆店家資訊？', '', {
        confirmButtonText: '確認',
        cancelButtonText: '取消'
      })
        .then(() => {
          const params = {
            SupplierId
          }
          apiAsset.Supplier.DeleteSupplier(params).then(res => {
            this.$message({
              message: '刪除成功',
              type: 'success'
            })
            this.getList(this.nowPage)
          }).catch(err => {
            console.log(err)
            this.$message({
              message: '刪除失敗',
              type: 'error'
            })
          })
        })
        .catch(() => {})
    },
    // 匯出廠商
    exportSupplier () {
      const { name, type, city, area, road } = this.filter
      const config = {
        responseType: 'blob',
        params: {
          'Filter.Name': name,
          'Filter.TypeIds': type,
          'Filter.City': city,
          'Filter.Area': area,
          'Filter.Address': road
        }
      }
      apiAsset.Supplier.GetExportExcelSupplier(config).then(res => {
        console.log(res)
        const url = window.URL.createObjectURL(new Blob([res.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `${dayjs().format('YYYYMMDD')}廠商清冊.xlsx`)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)
      }).catch(err => {
        console.log(err)
      })
    }
  }
}
</script>

<style lang="sass" scoped>
#news_main
  text-align: center
  padding: 50px 0 10px
  height: 100%
  .main
    min-width: 1140px
    max-width: 90%
    margin: 0 auto
    padding: 30px
    color: $mainFontColor
    background-color: #fff
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.1)
    border-radius: $pageBorderRadius
    box-sizing: border-box
    .title_bar
      display: flex
      justify-content: space-between
      align-items: center
      margin: 0 0 20px 0
      .title
        font-weight: bold
        font-size: map-get($fontSize,xx-large)
        margin-bottom: 10px
        text-align: left
      .tip
        font-size: map-get($fontSize,small)
        color: $subFontColor
    .title_bar.center
      margin: 20px 0 20px 0
    .newslist
      font-size: 15px
      .news-title
        cursor: pointer
        color: $mainColorDark
        text-decoration: underline
      ::v-deep .el-table
        +basicTable

  .el-pagination
    display: flex
    justify-content: flex-start
    margin-top: 28px
</style>
